import React from 'react';
import { connect } from 'react-redux';
import StatisticsByCreativeContent from './StatisticsByCreativeContent.js';
import { actions } from './StatisticsByCreativeContent.actions';

const StatisticsByCreativeContentComponent = connect(
    function mapStateToProps(state) {
        const storedMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.reportByCreative?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByCreativeContent);

export default StatisticsByCreativeContentComponent;
